"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.Label = exports.Fee = exports.DeliveryMethodTag = exports.DeliveryInfoWrapper = exports.CourierInfoWrapper = exports.CourierImage = exports.CourierDescription = exports.CourierBoxWrapper = exports.AddressRow = exports.AdditionalInfoWrapper = exports.AdditionalInfoText = exports.AdditionalInfoRow = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
const courierImageStyles = {
  height: 20,
  width: 'auto'
};
const ellipsisStyles = {
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis'
};
const Root = exports.Root = (0, _mui.styled)('section')(({
  theme
}) => ({
  background: theme.palette.common.white,
  boxSizing: 'border-box',
  width: '100%',
  maxWidth: 740,
  padding: theme.spacing(4, 3),
  [theme.breakpoints.up('sm')]: {
    borderRadius: theme.spacing(2),
    padding: theme.spacing(4, 6)
  }
}));
const Label = exports.Label = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  paddingBottom: theme.spacing(4)
}));
const AddressRow = exports.AddressRow = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  color: theme.palette.text.secondary,
  ...ellipsisStyles
}));
const DeliveryInfoWrapper = exports.DeliveryInfoWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  marginTop: theme.spacing(3)
}));
const AdditionalInfoWrapper = exports.AdditionalInfoWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  borderTop: `1px solid ${theme.palette.grey[200]}`,
  paddingTop: theme.spacing(3),
  marginTop: theme.spacing(3)
}));
const AdditionalInfoRow = exports.AdditionalInfoRow = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.spacing(2),
  '& + *': {
    marginTop: theme.spacing(2)
  }
}));
const AdditionalInfoText = exports.AdditionalInfoText = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  color: theme.palette.text.secondary,
  overflow: 'hidden',
  textOverflow: 'ellipsis'
}));
const DeliveryMethodTag = exports.DeliveryMethodTag = (0, _mui.styled)(_mui.Chip)(({
  theme
}) => ({
  marginBottom: theme.spacing(1)
}));
const CourierBoxWrapper = exports.CourierBoxWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: theme.spacing(3),
  borderTop: `1px solid ${theme.palette.grey[200]}`,
  paddingTop: theme.spacing(3),
  marginTop: theme.spacing(3)
}));
const CourierInfoWrapper = exports.CourierInfoWrapper = (0, _mui.styled)('div')({
  minWidth: 0
});
const CourierImage = exports.CourierImage = (0, _mui.styled)(_components.LazyImage)({
  ...courierImageStyles,
  [`& img`]: {
    objectFit: 'cover',
    ...courierImageStyles
  }
});
const Fee = exports.Fee = (0, _mui.styled)(_mui.Typography)(({
  ownerState: {
    isFreeDelivery
  },
  theme
}) => ({
  fontWeight: 'bold',
  color: theme.palette.text.secondary,
  ...(isFreeDelivery && {
    color: theme.palette.offer.main
  })
}));
const CourierDescription = exports.CourierDescription = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  color: theme.palette.text.secondary,
  fontWeight: 'bold',
  ...ellipsisStyles
}));
